import React from "react";
import {Props} from "./useBehaviour";
import {Input} from "antd";

export const View: React.FC<Props> = ({ onSearch }) => {
  return (
    <Input placeholder="Поиск" onChange={(e) => onSearch(e.currentTarget.value)} size="large" />
  )
}
